import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import React, { useEffect } from 'react';

import { HomeData } from '../../api/types';
import { RFID_SCANNING_TIMEOUT } from '../../utils/utils';
import { Banner } from '../Banner/Banner';
import { UserSiteAccessInfo } from '../UserSiteAccessInfo/UserSiteAccessInfo';

interface NFCScanResultProps {
    data: HomeData;
    translations: Record<string, string>;
    onReset: () => void;
    setRfid: React.Dispatch<React.SetStateAction<string | null>>;
    scannedUserPicture: string | undefined;
}

export const NFCScanResult: React.FC<NFCScanResultProps> = ({
    data,
    translations,
    onReset,
    setRfid,
    scannedUserPicture,
}) => {
    const { banner } = data;

    useEffect(() => {
        const timeout = setTimeout(onReset, RFID_SCANNING_TIMEOUT);
        return () => clearTimeout(timeout);
    }, [onReset]);

    useEffect(() => {
        setRfid(null);
    }, [setRfid]);

    return (
        <>
            {banner && <Banner banner={banner} translations={translations} />}

            <Card>
                <CardContent>
                    {data && scannedUserPicture && <UserSiteAccessInfo data={data} userPicture={scannedUserPicture} />}
                </CardContent>

                <CardActions style={{ display: 'none' }}>
                    <Button fullWidth color="primary" variant="contained" size="large" onClick={onReset}>
                        {translations.EMULATE_ACCESS_POINT_RESCAN_NFC_BUTTON}
                    </Button>
                </CardActions>
            </Card>
        </>
    );
};
